import type { OpenEventListenerParams } from './userProfileContext.types'

export class UserProfileUtils {
  static openEventListener({ elements, componentName, callback }: OpenEventListenerParams) {
    const handleOpenUserMentionProfile = (event: Event) => {
      event.preventDefault()
      event.stopPropagation()

      const target = event.target as HTMLAnchorElement
      const ucode = target.getAttribute('data-user-ucode') as string
      const customEvent = {
        detail: {
          ucode,
          componentName
        }
      } as unknown as React.MouseEvent

      callback({ customEvent, ucode })
    }

    elements?.forEach((element) => {
      element.addEventListener('click', handleOpenUserMentionProfile)
    })

    return () => {
      elements?.forEach((element) => {
        element.removeEventListener('click', handleOpenUserMentionProfile)
      })
    }
  }
}
